'use client';
import { runInAction, makeAutoObservable, action, computed, makeObservable, observable } from "mobx";
import { enableStaticRendering } from 'mobx-react-lite';
import { CMM } from 'Lib/Cmm';
import { authStore } from "store/authStore";

/**
 * 기타정보 관련 스토어 (MOBX)
 */
class EtcStore {
  etcStore = {
    notification_userIdx: '',
    notification_uuid: '',
    notificationEdit_uuid: '',

    keyword_selcard: [],

    answer_selcard: [],
    answer_search: '',
    answer_type: '',

    start_uuid: '',

  }
  constructor() {
    makeAutoObservable(this)
    // makeObservable(this,{
    //   etcStore: observable,
    //   initData: action,
    //   updMainData: action,
    //   updIsNotis: action,
    //   getNewCountChat: action,
    //   updChatLink: action, 

    // });
  }
  /**
   * init Data
   */
  async initData() {
    this.etcStore = {

      notification_userIdx: '',
      notification_uuid: '',
      notificationEdit_uuid: '',

      keyword_selcard: [],

      answer_selcard: [],
      answer_search: '',
      answer_type: '',

      start_uuid: '',
    }
  }

  /**
   * MainData 수정
  */
  updMainData(mainData) {
    this.etcStore = { ...this.etcStore, ...mainData };
  }

  get mainData() {
    return this.etcStore;
  }


}

export const etcStore = new EtcStore();
